import TrustStampLogo from './images/TrustStampLogoIcon.svg?react';
import { ReactNode } from 'react';
import { TrustStampDetailsWrapper } from '@/bundle/_Recipient/_Details/ui/RecipientDocumentVerification/TrustStampDetails/styles';

type TrustStampDetailsType = {
  children: ReactNode;
};

export const TrustStampDetails = ({ children }: TrustStampDetailsType) => {
  return (
    <TrustStampDetailsWrapper>
      <TrustStampLogo />
      {children}
    </TrustStampDetailsWrapper>
  );
};
